import getCategoriesApi from '../api';
import { getIcon } from '../categories.utils';
import { actions } from './categories.slice';
import { Category, CategoryDTO } from './types';

const getCategories = () => async (dispatch: any) => {
  try {
    const categoriesDto: CategoryDTO[] = await getCategoriesApi();
    const categories: Category[] = categoriesDto.map(dto => {
      const icon = getIcon(dto);
      return { ...dto, icon };
    });
    dispatch(actions.getCategoriesSuccess(categories));
  } catch (_e) {
    dispatch(actions.getCategoriesFailed());
  }
};

export default getCategories;
